import { render } from "./TopTemplate.vue?vue&type=template&id=456ee363&scoped=true&ts=true"
import script from "./TopTemplate.vue?vue&type=script&lang=ts"
export * from "./TopTemplate.vue?vue&type=script&lang=ts"

import "./TopTemplate.vue?vue&type=style&index=0&id=456ee363&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456ee363"]])

export default __exports__